import { useState } from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect, useSelector, useDispatch } from "react-redux";
import { renderField } from "../../../../Components/Forms/renders";
import { testChirpStackConnection } from "../Reducers/actions";

const selector = formValueSelector("sensorinstellingedit");

const SensorEditForm = ({handleSubmit}) => {
  const [testingConnection, setTestingConnection] = useState(false);
  const dispatch = useDispatch();
  const chirpstackUrl = useSelector(state => selector(state, "chirpstack.url"));
  const chirpstackApikey = useSelector(state => selector(state, "chirpstack.apikey"));
  const chirpstackTenantid = useSelector(state => selector(state, "chirpstack.tenantid"));

  const testChirpStackConnectionHandler = async () => {
    const resultDiv = document.getElementById("chirpstack-test-result");
    
    if (!chirpstackUrl || !chirpstackApikey || !chirpstackTenantid) {
      resultDiv.innerHTML = '<div class="alert alert-warning">Vul alle ChirpStack velden in voordat je test</div>';
      return;
    }

    setTestingConnection(true);
    resultDiv.innerHTML = '<div class="alert alert-info">Bezig met testen...</div>';

    try {
      const response = await dispatch(testChirpStackConnection({
        url: chirpstackUrl,
        apikey: chirpstackApikey,
        tenantid: chirpstackTenantid
      }));

      if (response.success) {
        let message = '✅ ChirpStack gRPC verbinding succesvol!';
        if (response.info) {
          message += `<br><small>gRPC: ${response.info.grpcUrl}</small>`;
        }
        if (response.warning) {
          message += `<br><small class="text-warning">⚠️ ${response.warning}</small>`;
        }
        resultDiv.innerHTML = `<div class="alert alert-success">${message}</div>`;
      } else {
        resultDiv.innerHTML = `<div class="alert alert-danger">❌ gRPC verbinding mislukt: ${response.error}</div>`;
      }
    } catch (error) {
      resultDiv.innerHTML = `<div class="alert alert-danger">❌ Fout: ${error.message}</div>`;
    } finally {
      setTestingConnection(false);
    }
  };

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <div className="mt-4 p-4 border">
                <strong>ChirpStack</strong>
                <Field name="chirpstack.url" type="input" component={renderField} label="ChirpStack Server URL" />
                <Field name="chirpstack.apikey" type="input" component={renderField} label="API Key" />
                <Field name="chirpstack.tenantid" type="input" component={renderField} label="Tenant ID" />
                <Field name="chirpstack.applicationPort" type="input" component={renderField} label="Application Port" />
                <Field name="chirpstack.applicationId" type="input" component={renderField} label="Application ID" />
                <Field name="chirpstack.mqttUrl" type="input" component={renderField} label="MQTT URL" />
                <div className="mt-2">
                  <button 
                    type="button" 
                    className="btn btn-info btn-sm" 
                    onClick={testChirpStackConnectionHandler}
                    disabled={testingConnection}
                  >
                    {testingConnection ? 'Bezig met testen...' : 'Test Connectie'}
                  </button>
                  <div id="chirpstack-test-result" className="mt-2"></div>
                </div>

              </div>
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Wijzigen" />
          </div>
        </div>
      </form>
    </div>
  );
};


const ReduxFormSensorEdit = reduxForm({
  form: "sensorinstellingedit", // a unique identifier for this form
})(SensorEditForm);

const mapStateToProps = (state) => ({
  initialValues: state.sensorinstellingen.item
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
